type StatusInput = {
  isLoading: boolean
  isError: boolean
}

export const unknownTooltip = ({ isLoading, isError }: StatusInput): string | undefined => {
  if (isLoading) {
    return 'Loading invoicing settings...'
  }
  if (isError) {
    return 'Could not load invoicing settings. Refresh the page to retry.'
  }
  return undefined
}
